// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__28JMJ","alertIcon":"ConfirmModal_alertIcon__2fDTf"};